export const title = "¡UPS! OCURRIÓ UN ERROR";
export const content = "Inténtelo más tarde";
export const connectionError = "Error de conexión";
